import { isSpSize } from "../common/utils/isSpSize";
import CenterParticles from "./bg/CenterParticles";
import TwinParticles from "./bg/TwinParticles";
import TripleParticles from "./bg/TripleParticles";

class Bg {
  // ---------------------------------------------------------------------------
  // --	Bg
  // ---------------------------------------------------------------------------

  constructor() {
    //PIXIアプリケーション生成
    this.app = new PIXI.Application({
      resolution: 1,
      antialias: false,
      transparent: true,
      view: document.querySelector(".js-bg-canvas"),
    });

    //FPSの最大値を設定
    this.app.ticker.maxFPS = 30;
    this.app.ticker.add(this.update.bind(this));

    //コンテナ配置
    this.container = new PIXI.Container();
    this.app.stage.addChild(this.container);

    //パーティクル生成
    this.center = new CenterParticles();
    this.container.addChild(this.center);
    this.twin = new TwinParticles();
    this.container.addChild(this.twin);
    this.triple = new TripleParticles();
    this.container.addChild(this.triple);

    //プレート
    this.plate = new PIXI.Graphics();
    this.plate.beginFill(0xffb81c);
    this.plate.drawRect(0, 0, 100, 100);
    this.plate.endFill();
    this.container.addChild(this.plate);
    this.center.setPlate(this.plate);

    //スクロールハンドリング
    window.addEventListener("scroll", this.onScroll.bind(this));
    this.onScroll();

    //リサイズハンドリング
    window.addEventListener("resize", this.onResize.bind(this));
    this.onResize();
  }

  // ---------------------------------------------------------------------------
  // --	アップデート
  // ---------------------------------------------------------------------------

  update() {
    this.center.update();
    this.twin.update();
    this.triple.update();
  }

  // ---------------------------------------------------------------------------
  // --	スクロール
  // ---------------------------------------------------------------------------

  onScroll() {
    const scrollY = window.scrollY;
    this.center.onScroll(scrollY);
    this.twin.onScroll(scrollY);
    this.triple.onScroll(scrollY);
  }

  // ---------------------------------------------------------------------------
  // --	リサイズ
  // ---------------------------------------------------------------------------

  onResize() {
    //Windowサイズ
    const wW = this.app.view.clientWidth;
    const wH = this.app.view.clientHeight;

    //基準となる幅
    const designW = isSpSize() ? 375 * 2 : 1366;
    const scale = designW / wW;

    //レンダラーのサイズを変更
    this.app.renderer.resize(designW, wH * scale);

    //コンテナをセンタリング
    this.container.x = this.app.renderer.width / 2;
    this.container.y = this.app.renderer.height / 2;

    //プレートサイズ
    this.plate.width = this.app.renderer.width;
    this.plate.height = this.app.renderer.height;
    this.plate.x = -this.plate.width / 2;
    this.plate.y = -this.plate.height / 2;
  }

  // ---------------------------------------------------------------------------
}

export default Bg;
